import actions from '../../actionTypes';

export default (email) => {
  return {
    type: actions.RESEND_VERIFY,
    email
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/resendVerify.js